import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UserFormReferralTrackRequestSchema,
  UserFormReferralTrackRequestType,
  UserFormReferralTrackResponseSchema,
  UserFormReferralTrackResponseType
} from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

interface UseFormReferralTrackInterface {
  formReferralTrackApi: UseMutateAsyncFunction<
    UserFormReferralTrackResponseType,
    unknown,
    UserFormReferralTrackRequestType,
    unknown
  >;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: MutationStatus;
  reset: () => void;
}

const useFormReferralTrack = (): UseFormReferralTrackInterface => {
  const { formsServiceAPI } = useFormsService();

  const trackFormReferral = (
    requestObject: UserFormReferralTrackRequestType
  ) => {
    try {
      UserFormReferralTrackRequestSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return formsServiceAPI
      .userFormReferralTrack(requestObject)
      .then((response) => {
        try {
          UserFormReferralTrackResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    trackFormReferral,
    {
      mutationKey: ['formReferralTrackApi']
    }
  );

  return {
    formReferralTrackApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useFormReferralTrack };
